/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:flex;flex-direction:column;height:100%}.navigation-context__loading[_ngcontent-%COMP%]{padding:16px;display:flex;justify-content:center}.navigation-context__search[_ngcontent-%COMP%]{position:relative;margin-bottom:8px}.navigation-context__input[_ngcontent-%COMP%]{padding-right:56px;width:100%}.navigation-context__clear[_ngcontent-%COMP%]{position:absolute;right:0;top:0}.navigation-context__selected[_ngcontent-%COMP%]{text-align:right}"];
export { styles as styles };
